<section>
    <div class="wifi">
        <div>
            <img src="../../../../assets/image/wifi-close.svg" alt="close" (click)="wifiClose()" class="wifi-close">
        </div>
        <!-- <div class="wifi">
        <img src="../../../../assets/image/wifi.svg" alt="wifi" class="wifi-background">
        </div> -->
        <div>
            <img src="../../../../assets/image/wifistudent.svg" alt="wifistudent" class="wifi-student">
        </div>
    </div>


    <div *ngIf="data">
        <div class="text-center pt-5">
            <p><span class="student_name">{{data.studentName}}</span></p>
            <p><span class="student_adm">Adm id: {{data.admNo}}</span></p>
        </div>
        <div class="container">
            <div id="student-card">
                <ul>
                    <li>Date of Birth</li>
                    <li>{{data.dob}}</li>
                </ul>
                <ul>
                    <li>Class Name</li>
                    <li>{{data.className}}</li>
                </ul>
                <ul>
                    <li>Section</li>
                    <li>{{data.section}}</li>
                </ul>
                <ul>
                    <li>Pro. Name</li>
                    <li>{{data.programName}}</li>
                </ul>
                <ul>
                    <li>Exm. Program</li>
                    <li>{{data.examProgram}}</li>
                </ul>

            </div>
        </div>
    </div>

    <div class="pt-2">
        <form [formGroup]="passwordForm" class="form_mlr">
            <div class="password_group">
                <label for="" class="pass">Password :</label>
                <input type="password" class="form-control" placeholder="Password" formControlName="password"
                    [type]="showPassword ? 'text' : 'password'">
                <span class="icon-pass">
                    <i alt="show" class="far fa-eye eye-show" (click)="showPassword = !showPassword"
                        [class.hide]="showPassword"></i>
                       <i alt="hide" class="far fa-eye-slash eye-hide" (click)="showPassword = !showPassword"
                        [class.hide]="!showPassword"></i>
                </span>                  
            </div>
            <div>
                <span *ngIf="submitted && passwordForm.get('password')?.errors?.['required']" class="error-message">
                    Password is required
                </span>
            </div> 
            <div class="confirmpassword_group">
                    <label for="" class="pass">Confirm Password :</label>
                    <input type="password" class="form-control" placeholder="Confirm Password"
                    formControlName="confirmPassword" [type]="showconfirmPassword ? 'text' : 'password'">
                    <span class="icon-confirmpass">
                        <i alt="show" class="far fa-eye eye-show"
                            (click)="showconfirmPassword = !showconfirmPassword" [class.hide]="showconfirmPassword"></i>
                        <i alt="hide" class="far fa-eye-slash eye-hide" (click)="showconfirmPassword = !showconfirmPassword"
                            [class.hide]="!showconfirmPassword"></i>
                    </span>
                  
            </div>
            <div>
                <span *ngIf="submitted && passwordForm.get('confirmPassword')?.errors" class="error-message">
                 {{ passwordForm.get('confirmPassword')?.errors?.['required'] ? 'Confirm Password is required' : 
                    (passwordForm.get('confirmPassword')?.errors?.['confirmPasswordValidator'] ? 'Password and Confirm Password didn\'t match.' : '') }}
                </span>
            </div>
        </form>
        <div class="text-center pt-4">
            <button type="button" class="reset" (click)="passwordReset()">Reset
                Password</button>
        </div>

    </div>
</section>